var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"co-flex-row co-items-center",class:[_vm.margin],staticStyle:{"cursor":"pointer"}},[_c('v-icon',{attrs:{"size":_vm.size,"color":_vm.color || 'blue-grey'}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }